<div
    #fab
  class="floating_action_button wiggle_animation"
  (mouseenter)="onMouseEnter($event)"
  (mouseleave)="onMouseLeave($event)"
  (click)="onClick($event)"
></div>
